'use client'

import { Container, Row } from 'react-bootstrap'
import parse from 'html-react-parser'

import appTile from '@/assets/images/app-tile.svg'
import iosButton from '@/assets/images/coming-soon/app-store.svg'
import googleButton from '@/assets/images/coming-soon/google-button.svg'

function GetMyalrajhi({ heading = 'Get MY alrajhi' }) {
  return (
    <div className="container p-3 p-sm-0" id="get-my-alrajhi">
      <Container fluid className="inward-container">
        <Row>
          <div data-aos="fade-up" data-aos-delay="150">
            <h2 className="heading-36 mb-5">
              {parse(heading)}
              <span className="ms-4">
                <img src={appTile.src} alt="Download on iOS" width="60px" height="60px" />
              </span>
            </h2>
            <div className="col" style={{ paddingBottom: '0px' }}>
              <div className="ccm-custom-style-container  ccm-custom-style-downloadsectionbuttons-353">
                <p className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-4 gap-md-3 m-0">
                  <a
                    href="https://apps.apple.com/my/app/my-alrajhi/id1587293861"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      maxWidth: '200px'
                    }}
                  >
                    <img src={iosButton.src} alt="Download on iOS" width="100%" height="auto" />
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=my.com.alrajhibank.wick"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      maxWidth: '200px'
                    }}
                  >
                    <img
                      src={googleButton.src}
                      alt="Download on Google Play"
                      width="100%"
                      height="auto"
                    />
                  </a>
                </p>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  )
}

export default GetMyalrajhi
